import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	columnHeaderMergedColumn: {
		id: 'native-issue-table.common.utils.get-merged-column-config.column-header-merged-column',
		defaultMessage: 'Work items',
		description: 'Column header for merged column',
	},
});
